
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_2","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 32 32","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M30.4 8.4c-.1-.2-.3-.2-.5-.2h-5.4c-.3 0-.6.3-.6.6s.3.6.6.6h4.6l-3.5 12.5H10.7L7.6 9.4h4.6c.3 0 .6-.3.6-.6s-.3-.6-.6-.6h-5L5.9 2.6c0-.3-.3-.5-.6-.5H2.1c-.3 0-.6.3-.6.6s.3.6.6.6h2.8l4.8 19.2c0 .4.3.5.6.5h15.9c.3 0 .5-.2.6-.4l3.8-13.7c0-.2-.1-.4-.2-.5zM11.9 24.5c-1.5 0-2.8 1.3-2.8 2.8 0 1.5 1.3 2.8 2.8 2.8 1.5 0 2.8-1.3 2.8-2.8 0-1.5-1.3-2.8-2.8-2.8zm0 4.4c-.9 0-1.6-.7-1.6-1.6 0-.9.7-1.6 1.6-1.6.9 0 1.6.7 1.6 1.6 0 .9-.7 1.6-1.6 1.6zM23.9 24.5c-1.5 0-2.8 1.3-2.8 2.8 0 1.5 1.3 2.8 2.8 2.8 1.5 0 2.8-1.3 2.8-2.8 0-1.5-1.2-2.8-2.8-2.8zm0 4.4c-.9 0-1.6-.7-1.6-1.6 0-.9.7-1.6 1.6-1.6.9 0 1.6.7 1.6 1.6 0 .9-.7 1.6-1.6 1.6z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M18.1 13.1c2.6 0 4.7-2.1 4.7-4.7s-2.1-4.7-4.7-4.7-4.7 2.1-4.7 4.7 2.1 4.7 4.7 4.7zm0-8.2c1.9 0 3.5 1.6 3.5 3.5s-1.6 3.5-3.5 3.5-3.5-1.6-3.5-3.5 1.6-3.5 3.5-3.5z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M16.1 10.1c.1.1.3.2.5.2.1 0 .3-.1.4-.2l1.2-1 1.2 1c.1.1.3.2.4.2.2 0 .3-.1.5-.2.2-.3.2-.6-.1-.9l-1.1-.9 1.1-.9c.3-.2.3-.6.1-.9-.2-.3-.6-.3-.9-.1l-1.2 1-1.2-1c-.2-.2-.6-.2-.9.1-.2.3-.2.6.1.9l1.1.9-1.1.9c-.3.3-.3.7-.1.9zM24.4 10.9c-.4 0-.8.2-1 .6-.9 2-2.9 3.4-5.2 3.4s-4.3-1.4-5.2-3.4c-.2-.4-.5-.6-1-.6h-1.4c-.7 0-1.2.6-1 1.3l1.9 7.6c.1.5.5.8 1 .8H24c.5 0 .9-.3 1-.8l1.9-7.6c.2-.7-.3-1.3-1-1.3h-1.5z"}})])
          )
        }
      }
    